//英文 (美国)
export default {
  urlBase: "/en",
  basePrev: "en",
  baseSuffix: "En",
  tarnsUrl: "",
  lang: "english",
  reversalLang: "chinese",
  stylePrev: "-en",
  ubsSuffox: "/english",
  index: {
    loginCookie: "isEnLogin",
    userIdCookie: "pWebEnUserId",
    userNameCookie: "pWebEnUsername",
    welcome: "Welcome",
    login: "Login",
    signUp: "Sign Up",
    setting: "Edit Profile",
    news: "Latest Release",
    Logout: "Logout",
    browseTopics: "Browse Topics",
    monthly: "Monthly",
    quarterly: "Quarterly",
    annual: "Annual",
    dataMap: "Data Map",
    visualization: "Data Visualization Gallery",
    releaseSchedule: "Release Schedule",
    today: "Today",
    noreleasetoday: "No release today.",
    tomorrow: "Tomorrow",
    noreleasetomorrow: "No release tomorrow.",
    macroeconomic: "Macroeconomic Performance",
    gnsczz: "Gross Domestic Product, Accumulated",
    jmxfjgzs: "Consumer Price Index",
    gysczccjgzs: "Producer Price Index for Industrial Products",
    lscl: "Output of Grain Crops",
    gyzjzzs: "Value-added of Industry, Accumulated Growth Rate",
    shxfplsze: "Total Retail Sales of Consumer Goods",
    gdzctzzs: "Investment in Fixed Assets, Accumulated Growth Rate",
    hotTopics: "Understanding Statistics",
    unit: "Unit",
    yiyuan: "100 million yuan",
    wandun: "10000 tons",
    percent: "%",
    snty100: "The _same month last year=100",
    ljz: "Accumulated",
    ljtbzj: "Accumulated Growth Rate",
    bq: "Current Period",
    bqlj: "Current Period Accumulated",
    langsChange: "Chinese",
  },
  home: {
    urlkey: "url_en",
  },
  register: {
    country: "",
  },
  nav: {
    home: "Home",
    monthly: "Monthly",
    quarterly: "Quarterly",
    annual: "Annual",
    hongKongYearData: "hongKongYearData",
    macaoYearData: "macaoYearData",
    taiwanYearData: "taiwanYearData",
    visualization: "Visualization",
    publications: "Publications",
    favorites: "Favorites",
    help: "Help",
    regional: "Regional",
    fsMonthData: "Monthly By Province",
    fsQuarterData: "Quarterly By Province",
    fsYearData: "Annual By Province",
    mainMonthData: "Monthly Prices By Selected Cities",
    mainYearData: "Annual By Selected Cities",
    inOutTable: "In And Out",
    fundFlowTable: "Fund And Flow",
    browseTopics: "Browse Topics",
  },
  dataPage: {
    downNumMessage: "You have exceeded the maximum download data limit, please reselect the data and download!",
    browseTopics: "Browse Topics",
    simpleSearch: "Browse Topics",
    advancedSearch: "Advanced Search",
    addToFavorite: "Add to favorite",
    tips: "Note",
    newIndicator: "New Indicator",
    jjtb: "Visualized",
    filter: "Filter",
    statistics: "Statistics",
    qckhkl: "Delete Blank Row and Column",
    hlhh: "Transform Dimensions",
    indicatorsTips: "Explanatory Notes of Indicators",
    newIndicatorDesc: "Please select indicators from the list.",
    noNewIndicator: "Input operation symbol.",
    noSelectNewIndicator: "Selected indicators cannot be empty.",
    formulaError: "Check the formula",
    duplicateName: "Indicator name cannot be duplicate",
    selectedIndicator: "Please select an indicator",
    regionLabel: "Region",
    timeLabel: "Time",
    regionalLabel: "Regional",
    timeLabel2: "Time",
    xulie: "Sequence",
    year: "",
    nationalTotal: "National Total",
    hanglie: "Row and line are same",
    nokong: "Input cannot be empty",
    noData: "Sorry, we were unable to find any information that meets the query criteria.",
  },
  tree: {
    indicators: "Indicators",
  },
  report: {
    title: "Browse Topics",
    report: "Report Forms",
    monthly: "Monthly",
    quarterly: "Quarterly",
    annual: "Annual",
    hongKongYearData: "hongKongYearData",
    macaoYearData: "macaoYearData",
    taiwanYearData: "taiwanYearData",
  },
  sidebar: {
    gjtjj: "NBS",
    help: "Help",
    toTop: "Top",
  },
  pageFooter: {
    copyright: "©2014 National Bureau of Statistics of China, All Rights Reserved.",
    phoneNumber: "Telephone：010-68576320",
    time: "Mon - Fri, 8:30-11:30, 13:30-16:30",
    address: "Address: No 57, YueTan Nan St., Xicheng, Beijing,100826",
    webCode: "",
  },
  news: {
    prevText: "Prev",
    nextText: "Next",
  },
  superSearch: {
    selectAll: "Select All",
    Invert: "Invert Selection",
    clearAll: "Clear Selections",
    deleteAll: "Delete All",
    deleteUnselectedItems: "Delete Unselected Items",
    query: "Query",
    Article: "Article",
    Items: "Items",
    ResultsScreening: "Results Screening",
    query2: "Query",
  },
  favorites: {
    pageTitle: "Favorites",
    placeholder: "Please enter a name",
    newFavorites: "New Favorites",
    name: "Name",
    sourceDatabase: "Source Database",
    createdDate: "Date of Creation",
    operation: "Operation",
    placeholder1: "Please enter the name",
    placeholder2: "Please enter the serial number",
    orderNum: "Order",
    newFavoritesTitle: "Create in My Favorites",
    deletion: "Are you sure you want to delete?",
    tips: "Tips",
    blankName: "The name cannot be blank.",
    blankOrder: "Please fill in the order number",
    isNumber: "Please enter a pure number for the serial number",
    saveSuccess: "New successfully created",
    loginFirst: "Session timed out or not logged in",
    login: "Login",
    savePath: "Save path",
    collectionSuccessful: "Collection Successful",
    addFavoritesFirst: "Please add a favorite first",
  },
  targetSelect: {
    indicators: "Indicators",
    noIndicator: "No Data",
  },
  timeSelectByPeriod: {
    eg: "e. g:",
    mo: "Mo",
    qr: "Qr",
    yr: "Yr",
    ot: "OT",
    time: "Time",
    submit: "Submit",
  },
  timeSelect: {
    monthFormat: "MMM yyyy",
    yearFormat: "yyyy",
    mPlaceholder: "Choose of Month",
    yPlaceholder: "Choose of Year",
    qPlaceholder: "Choose of Quarter",
  },
  timeQuqrterPicker: {
    label: "Quarter",
    placeholder: "Choose of Quarter",
  },
  stat_base: {
    sum: "Sum",
    sum1: "Sum",
    mean: "Mean",
    max: "MAX",
    min: "MIN",
    median: "Median",
    mode: "Mode",
    variance: "Variance",
    standardDeviation: "Standard Deviation",
  },
  editMenu: {
    titleKey: "enTitle",
  },
  economicOperation: {
    year: "",
  },
  loadingText: "loading",
  empty: "No Data",
  more: "More",
  download: "download",
  print: "print",
  save: "Save",
  reset: "Reset",
  dataManage: "Data Management",
  reportManage: "Management of Forms",
  recover: "Restore",
  dimensionConversion: "Transform Dimensions",
  saveDefault: "Save As Default",
  restoreDefaults: "Restore Default",
  cancel: "Cancel",
  region: "Region",
  row: "Row",
  col: "Column",
  ok: "OK",
  edit: "Edit",
  delete: "Delete",
  go: "GO",
  confirm: "Confirm",
  submit: "Submit",
  saveSuccess: "Save Successful",
  count: {
    greaterThan: "greater than",
    smallerThan: "smaller than",
    greaterThanOrEqualTo: "greater than or equal to",
    smallerThanOrEqualTo: "smaller than or equal to",
    value: "value",
    enterFilter: "Please enter filter Items.",
    selectFilter: "Please select filter Items.",
    emptyFilter: "Filter criteria cannot be empty",
  },
  map: {
    showStyle: "Style",
    colorChart: "Color Chart",
    bubbleChart: "Bubble Chart",
    barChart: "Bar Chart",
    barlineChart: "Bar Line Chart",
    txChart: "Bar chart",
    pieChart: "Pie Chart",
    color: "Color",
    shape: "Shape",
    clear: "Clear",
    legend: "Legend",
    fsMonth: "Monthly",
    fsQuarter: "Quarterly",
    fsYear: " Annual",
    keyForFilter: "Enter a keyword to filter",
    vector: "vector",
    shadow: "shadow",
    DarkTheme: "Dark",
    StandardTheme: "Standard",
    WhiteTheme: "White",
    BlueTheme: "Blue",
    EmptyTheme: "Empty",
  },
  weeks: {
    sun: "Sun",
    mon: "Mon",
    tue: "Tue",
    wed: "Wed",
    thu: "Thu",
    fri: "Fri",
    sat: "Sat",
  },
  quarter: {
    q1: "1Q",
    q2: "2Q",
    q3: "3Q",
    q4: "4Q",
  },
  placeholders: {
    chooseYear: "Choose Of Year",
    chooseMonth: "Choose Of Month",
    chooseQuarter: "Choose Of Quarter",
    choose: "Seleted",
    tips: "Tips",
    confirmLogout: "Confirm Logout？",
    cancel: "Cancel",
    confirm: "Confirm",
    logoutSuccess: "Logout Success",
    chooseArea: "Choose Region",
  },
  daochu: {
    gjtjj: "National Bureau of Statistics",
    database: "Database",
    time: "Time",
    note: "Note",
    source: "Data Sources",
    area: "Area",
    gjsj: "National Data",
    quanguo: "National",
  },
  login: {
    welcome: "Welcome",
    email: "ID",
    emailPlaceholder: "Email cannot be blank",
    emailError: "Please enter correct email",
    password: "Password",
    passwordPlaceholder: "Password cannot be blank",
    verificationCode: "Verification code",
    codePlaceholder: "Verification code cannot be blank",
    remember: "Remember me",
    login: "Login",
    loginSuccess: "login success",
    newUser: "Register",
    forgetPassword: "Forget Password",
    editPassword: "Change Password",
    register: "Register",
    password2: "Re-enter Password",
    password2Placeholder: "Two Password cannot be blank",
    passwordQuestion: "Password Question",
    questionPlaceholder: "Password Question cannot be blank",
    passwordAnswer: "Password Answer",
    answerPlaceholder: "Password Answer cannot be blank",
    phone: "Mobile-Phone",
    phonePlaceholder: "Please enter mobile-phone",
    nation: "Nation",
    nationPlaceholder: "Please enter nation",
    professional: "Professional",
    professionalPlaceholder: "Please enter professional",
    job: "Job",
    jobPlaceholder: "Please enter job",
    ydmzsm: "I have read the disclaimer",
    submit: "Submit",
    psdLess8: "The password may not be less than 8 characters！",
    psdWeak: "The password is too weak, must contain letters！",
    twoPsdNotMatch: "Two passwords do not match!",
    phoneError: "The format of the mobile phone number is incorrect!",
    registerSuccess: "Register Success",
    inputNewPsd: "New Password",
    oldPassword: "Old Password",
    newPsdPlaceholder: "New Password cannot be blank",
    oldPsdPlaceholder: "Old Password cannot be blank",
    inputNewPsd2: "Re-enter Password",
    newPsd2Placeholder: "Re-enter Password cannot be blank",
    back: "Back",
    editSuccess: "edit success",
    setting: "Setting",
    mzsm: "Disclaimer",
  },
  scheduleUrl: "http://www.stats.gov.cn/english/PressRelease/ReleaseCalendar/202301/t20230106_1891505.html",
  protocol: {
    title: "User Agreement",
    main1: "Welcome, and thank you for using NBS database. The agreement elaborates all of the terms and policies should be obeyed when you are using NBS database.",
    main2: "If you are using or a registered user of NBS database, we you are agreeing to our terms, so please take a few minutes to read over the User Agreement below.",
    copyright: "Copyright Statements",
    c1:
      "1.The copyright of all contents (data, graphics, trademark, design, text, and etc.) of this database belongs to the National Bureau of Statistics of the People’s Republic of China unless as other indicated.",
    c2:
      "2. The contents of this database can but be used as news and/or free information through reprint or quotation reasonably and in good will, and the reprint or quotation of this database should be clearly indicated as “Source: National Bureau of Statistics”",
    c3: "3. The contents of this database are not allowed to be used for following activities through reprint or quotation:",
    c31: "A. Distorted or modified the original intention of this database;",
    c32: "B. Damaging the interests of this database or other people;",
    c33: "C. Any offence against the law;",
    c34: "D. Any behavior that may damage public orders.",
    c4:
      "4. Any third parties intent to add hyperlinks to this database, shall obtain permission from the National Bureau of Statistics. The National Bureau of Statistics holds the right to decide whether to approve the hyperlink. These linked websites are not under the control of the National Bureau of Statistics, and the NBS is not responsible for the contents of any linked web or any hyperlink contained in a linked website. The hyperlinks do not imply any collaboration between the National Bureau of Statistics and the third party website, nor acknowledgement to the third party websites.",
    c5: "5. The NBS is entitled to tracking out the legal obligations of those who fail to observe this declaration and those who violate the law.",
    liability: "Disclaimer",
    l1: "1. The National Bureau of Statistics shall be under no liability whatsoever including the usage of this database, while following situations occur:",
    l11: "（1）Any direct or consequential loss caused by data, including profit, revenue or investment loss.",
    l12: "（2）Any unpredictability factor lead to losses.",
    l13:
      "（3）Irrational incidents that not under control of the National Bureau of Statistics and the third party providing the service, including internet traffic interruption, delay or data error, virus in telecommunications, networking and computers, as well as data distortion caused by malfunctions in communications facilities, and etc.",
    l2:
      "2、Any third party content being quoted, abstracted, and reprinted in this database is for visitors’ reference anddoesn't represent the views of the National Bureau of Statistics.",
    privacy: "Privacy",
    p1: "1. NBS collects your registration information that used to offer better service and products with more understanding on your needs.",
    p2:
      "2. NBS respects and protects your privacy, and your registration information (including user name, email address and etc.,) will not be released to any third party without your permission or mandatory provisions by relevant laws.",
    append: "Supplementary",
    a1:
      "1. Issues and terms not covered in this User Agreement, please refer to the relevant national laws and regulations. When this agreement is conflicted with national laws and regulations, the laws and regulations shall prevail.",
    a2: "2.All rights of interpretation, modification and update in this agreement shall remain to the National Bureau of Statistics.",
  },
  area: {
    110000000000: "Beijing",
    120000000000: "Tianjin",
    130000000000: "Hebei",
    140000000000: "Shanxi",
    150000000000: "Inner Mongolia",
    210000000000: "Liaoning",
    220000000000: "Jilin",
    230000000000: "Heilongjiang",
    310000000000: "Shanghai",
    320000000000: "Jiangsu",
    330000000000: "Zhejiang",
    340000000000: "Anhui",
    350000000000: "Fujian",
    360000000000: "Jiangxi",
    370000000000: "Shandong",
    410000000000: "Henan",
    420000000000: "Hubei",
    430000000000: "Hunan",
    440000000000: "Guangdong",
    450000000000: "Guangxi",
    460000000000: "Hainan",
    500000000000: "Chongqing",
    510000000000: "Sichuan",
    520000000000: "Guizhou",
    530000000000: "Yunnan",
    540000000000: "Xizang",
    610000000000: "Shaanxi",
    620000000000: "Gansu",
    630000000000: "Qinghai",
    640000000000: "Ningxia",
    650000000000: "Xinjiang",
    710000000000: "Taiwan",
    810000000000: "HongKong SAR",
    820000000000: "Macao SAR",
  },
  date: {
    year: "{yyyy}",
    month: "{mm} {yyyy}",
    quarter: "{ss}Q {yyyy}",
  },
  chartTable: {
    row: "row",
    column: "column",
    bt: "title",
    remark1: "Explanation: If too many drawing items are selected, it may affect the normal display of the legend.",
    tuxing: "chart type",
    zhu: "bar",
    xian: "line",
    isCzz: "secondary axis",
    leiAdd: "cumulative",
    showDataLable: "show data label",
  },
};
